/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Pair } from './pair';

export interface CryptoComDeal {
  id?: number;
  dealId?: string;
  symbol?: string;
  orderId?: number;
  pairId?: number;
  pair?: Pair;
  side?: CryptoComDeal.SideEnum;
  price?: number;
  quantity?: number;
  status?: CryptoComDeal.StatusEnum;
  createTime?: string;
  lastUpdateTime?: string;
  ackSent?: boolean;
  ackSendTime?: string;
}
export namespace CryptoComDeal {
  export const SideEnum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type SideEnum = (typeof SideEnum)[keyof typeof SideEnum];
  export const StatusEnum = {
    Accept: 'ACCEPT',
    Reject: 'REJECT',
    Pending: 'PENDING',
  } as const;
  export type StatusEnum = (typeof StatusEnum)[keyof typeof StatusEnum];
}
